<template>
  <div>
    <h2 class="all-caps">ER Contacts</h2>
      <v-dialog v-model="removeERContactDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Remove ER Contact?</v-card-title>
          <v-card-text>
            This will remove {{ deleteDialogItem.name }}.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" flat @click="removeERContactDialog = false">Nevermind</v-btn>
            <v-btn color='error' small :loading="apiCallPending" @click="removeERContact(deleteDialogItem)">
              Remove
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout @mouseover="showRemove = contact" @mouseout="showRemove = null" row align-center v-for="contact in contacts" class="info-listing mb-2">
        <v-flex shrink v-show="showRemove === contact" class="mr-1 transition-fast-in-fast-out">
          <v-icon @click="openRemoveERContactDialog(contact)">cancel</v-icon>
        </v-flex>
        <v-flex>
          <ul class="info-listing mb-2">
            <li>{{ contact.name }} | {{ contact.relation }}</li>
            <li v-for="phone in contact.phone_numbers">
              <span>{{ phone.phone_type }}:</span> {{ phone.number | phone }}</span>
            </li>
          </ul>
        </v-flex>
      </v-layout>

    <v-dialog v-model="newERContactDialog" max-width="350">
      <v-btn slot='activator' color="primary">
        <v-icon left>
          add
        </v-icon>
        Add New
      </v-btn>
      <v-card>
        <v-card-title class="headline">Add ER Contact</v-card-title>
        <v-card-text>
          <v-text-field label="Contact Name" v-model="contactName">
          </v-text-field>
          <v-text-field label="Relationship" v-model="contactRelation">
          </v-text-field>
          <v-select :items="phoneTypes" label="Phone Type" v-model="contactPhone1Type">
          </v-select>
          <v-text-field label="Number" mask="phone" v-model="contactPhone1Number">
          </v-text-field>
          <v-select :items="phoneTypes" label="Phone Type" v-model="contactPhone2Type">
          </v-select>
          <v-text-field label="Number" mask="phone" v-model="contactPhone2Number">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" flat @click="newERContactDialog = false">Nevermind</v-btn>
          <v-btn color='success' small :loading="apiCallPending" @click="createERContact">
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: [
    'employeeId',
    'contacts',
    'afterCallback'
  ],
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    exampleComputed: function () {
      return this.example
    },
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
      showRemove: null,
      newERContactDialog: false,
      removeERContactDialog: false,
      deleteDialogItem: {},
      apiCallPending: false,
      contactName: '',
      contactRelation: '',
      contactPhone1Type: 'Cell',
      contactPhone1Number: '',
      contactPhone2Type: '',
      contactPhone2Number: '',
      phoneTypes: [
        "Home",
        "Work",
        "Cell",
        "Other"
      ],
    }
  },
  methods: {
    openRemoveERContactDialog (contact) {
      this.removeERContactDialog = true
      this.deleteDialogItem = contact
    },
    removeERContact (contact) {
      this.apiCallPending = true
      this.$store.dispatch('employees/removeERContact',
        contact.id
      ).finally(res => {
        if(this.afterCallback) {
          console.log('running after callback')
          this.afterCallback()
          console.log('done with after callback!')
        }
        this.apiCallPending = false
        this.removeERContactDialog = false
      })
    },
    createERContact () {
      this.apiCallPending = true
      var params = {
        id: this.employeeId,
        emergency_contacts_attributes: [
          {
            name: this.contactName,
            relation: this.contactRelation,
            phone_numbers_attributes: []
          }
        ]
      }
      if (this.contactPhone1Type && this.contactPhone1Number) {
        params.emergency_contacts_attributes[0].phone_numbers_attributes.push(
          {
            phone_type: this.contactPhone1Type,
            number: this.contactPhone1Number
          },
        )
      }
      if (this.contactPhone2Type && this.contactPhone2Number) {
        params.emergency_contacts_attributes[0].phone_numbers_attributes.push(
          {
            phone_type: this.contactPhone2Type,
            number: this.contactPhone2Number
          },
        )
      }

      this.$store.dispatch('employees/update',
        params
      ).finally(res => {
        if(this.afterCallback) {
          console.log('running after callback')
          this.afterCallback()
          console.log('done with after callback!')
        }

        this.apiCallPending = false
        this.newERContactDialog = false
        this.contactName = ''
        this.contactRelation = ''
        this.contactPhone1Type = ''
        this.contactPhone1Number = ''
        this.contactPhone2Type = ''
        this.contactPhone2Number = ''
      })
    },
  },
}
</script>

<style scoped>
</style>
